import { render, staticRenderFns } from "./worksAdministration.vue?vue&type=template&id=6449a849&scoped=true"
import script from "./worksAdministration.vue?vue&type=script&lang=js"
export * from "./worksAdministration.vue?vue&type=script&lang=js"
import style0 from "./worksAdministration.vue?vue&type=style&index=0&id=6449a849&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449a849",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6449a849')) {
      api.createRecord('6449a849', component.options)
    } else {
      api.reload('6449a849', component.options)
    }
    module.hot.accept("./worksAdministration.vue?vue&type=template&id=6449a849&scoped=true", function () {
      api.rerender('6449a849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/works/worksAdministration.vue"
export default component.exports